"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Calendar_ButtonAriaLabel: "Calendar",
                Input_DatePickerClear: "Clear",
                Input_DatePickerMonthLabel: "Month",
                Input_DatePickerNextMonth: "Next month",
                Input_DatePickerPreviousMonth: "Previous month",
                Input_DatePickerSessionDate: "Session Date",
                Input_DatePickerToday: "Today",
                Input_DatePickerYearLabel: "Year",
                Input_InvalidDateAfterMax: "'{0}' is after the maximum allowable date of {1}.",
                Input_InvalidDateBeforeMin: "'{0}' is before the minimum allowable date of {1}.",
                Input_InvalidDateValue: "'{0}' is not a valid Date. Please enter date in {1} format.",
            }
        });
        /**
         * Framework class for Date controls
         */
        var Date = /** @class */ (function (_super) {
            __extends(Date, _super);
            function Date() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Date.prototype.init = function (data, element) {
                this.formatPatterns = this._createFormatPatterns();
                _super.prototype.init.call(this, data, element);
            };
            Date.prototype.getTaskGuideParams = function (options) {
                if (!this._pickerOpenObserver) {
                    this._pickerOpenObserver = $dyn.observe(this.pickerOpen, function () {
                        if ($dyn.ax && $dyn.ax.taskGuide && $dyn.ax.taskGuide.repositionGuidedQtip && !$dyn.value($dyn.ax.taskGuide.repositionGuidedQtip)) {
                            $dyn.async(function () {
                                $dyn.ax.taskGuide.repositionGuidedQtip(true);
                            }, 0, "reset task guide qtip");
                        }
                    });
                }
                options = _super.prototype.getTaskGuideParams.call(this, options);
                var target;
                if (this.pickerOpen()) {
                    target = $(".ui-datepicker");
                }
                else {
                    target = $(this.element);
                }
                options.target = target;
                options.avoidRailsModeBlocks = true;
                return options;
            };
            /**
             * Gets the format used to display the value to the user
             * @returns The display format for the control
             */
            Date.prototype.displayFormat = function () {
                var format = "";
                if ($dyn.value(this.formatPatterns) && $dyn.value(this.formatPatterns).display) {
                    format = $dyn.value(this.formatPatterns).display;
                }
                return format;
            };
            /**
             * Get the specified value or the _parsedValue as a moment object with the timezone preference applied
             * @param valueForConstructor The optional date string
             * @returns The moment object
             */
            Date.prototype.getMoment = function (valueForConstructor) {
                if (!valueForConstructor) {
                    valueForConstructor = this._parsedValue;
                }
                if (valueForConstructor && valueForConstructor.indexOf("T") !== -1) {
                    // If the date contains a time portion add the Z so all browser parse the value consistently.
                    valueForConstructor += "Z";
                }
                else {
                    // If it is just a date add a time portion to force it to parse as UTC.
                    valueForConstructor += "T00:00:00Z";
                }
                // The value should come down from the server in ISO 8601 standard date format so it can be used by the JS Date constructor
                var valueAsDate = new window.Date(valueForConstructor);
                var dateAsMoment = moment(valueAsDate);
                dateAsMoment = this._applyTimeZonePreference(dateAsMoment);
                return dateAsMoment;
            };
            /**
             * The formattedValue getter
             * @param skipValidation If true disregard the validity of the control
             * @returns The formatted value for the control
             */
            Date.prototype.getFormattedValue = function (skipValidation) {
                if (skipValidation === void 0) { skipValidation = false; }
                // we may need the current formatted value regardless of validation
                var isValid = skipValidation ? true : $dyn.peek(this.IsValid);
                var value = this._parsedValue;
                // If the controls is in an invalid state we want to keep showing the user entered value.
                var dateString = isValid ? "" : this._lastUserValue;
                if (value && (isValid || dateString === undefined)) {
                    dateString = this._formatDateValueForDisplay(value);
                }
                return dateString;
            };
            Date.prototype.setFormattedValue = function (userValue, forceChange, forceCommandCall) {
                if (forceChange === void 0) { forceChange = false; }
                if (forceCommandCall === void 0) { forceCommandCall = false; }
                var result;
                userValue = userValue.trim();
                var logMessages = this.shouldControlLogMessage(userValue);
                this._lastUserValue = userValue;
                if (!this.pickerOpen()) {
                    if (logMessages) {
                        this.removeMessages();
                    }
                    if (userValue) {
                        var dateTime = this.parseMoment(userValue);
                        if (dateTime && dateTime.isValid()) {
                            if (dateTime.isAfter($dyn.util.time.maxDate)) {
                                var maxDateFormatted = this._applyTimeZonePreference(moment($dyn.util.time.maxDate)).format(this.displayFormat());
                                if (logMessages) {
                                    $dyn.warn({ Message: $dyn.format($dyn.label("Input_InvalidDateAfterMax"), userValue, maxDateFormatted), Label: "Input_InvalidDateAfterMax" }, this);
                                }
                                this._lastValidationResult = false;
                                this.IsValid(false);
                            }
                            else if (dateTime.isBefore($dyn.util.time.minDate)) {
                                var minDateFormatted = this._applyTimeZonePreference(moment($dyn.util.time.minDate)).format(this.displayFormat());
                                if (logMessages) {
                                    $dyn.warn({ Message: $dyn.format($dyn.label("Input_InvalidDateBeforeMin"), userValue, minDateFormatted), Label: "Input_InvalidDateBeforeMin" }, this);
                                }
                                this._lastValidationResult = false;
                                this.IsValid(false);
                            }
                            else {
                                result = this.setDate(dateTime, forceChange, forceCommandCall);
                            }
                        }
                        else {
                            // TODO: Is this.displayFormat() the right thing to use here? It doesn't get localized, should it be shown?
                            if (logMessages) {
                                this.warn($dyn.format($dyn.label(this.errorMessageLabel), userValue, this.displayFormat()), this.errorMessageLabel);
                            }
                            this._lastValidationResult = false;
                            this.IsValid(false);
                        }
                    }
                    else {
                        // Clear the date.
                        result = this.setDate(null);
                    }
                }
                if (!result) {
                    result = $.Deferred();
                    result.resolve();
                }
                return result;
            };
            /**
             * Gets today as a moment object
             * @returns Today in a moment object
             */
            Date.prototype.getTodayMoment = function () {
                // We keep all the dates in UTC TZ for the date control, but we need to get todays date for the users TZ and make it a UTC date.
                // We don't combine with the time since this is also overriden by the DateTime control since it has different behavior.
                var todayUserMoment = moment().tz("User");
                var todayMoment = moment().utc();
                todayMoment.year(todayUserMoment.year());
                todayMoment.month(todayUserMoment.month());
                todayMoment.date(todayUserMoment.date());
                return todayMoment;
            };
            /**
             * Set the backing value with a date object
             * @param date Desired date time in UTC
             * @param forceChange Whether to force a call setValue even if the specified date is the same as the backing value
             * @param forceCommandCall Whether to call SetValue command no matter what
             * @returns The promise from the setValue call
             */
            Date.prototype.setDate = function (date, forceChange, forceCommandCall) {
                if (forceChange === void 0) { forceChange = false; }
                if (forceCommandCall === void 0) { forceCommandCall = false; }
                // The value should be saved in ISO 8601 standard date format or empty if a date is not present.
                var newValue = "";
                var result;
                if (!!date) {
                    var dateAsMoment = moment(date);
                    newValue = dateAsMoment.utc().format(this.valueFormatPattern);
                }
                if (forceChange || newValue !== this._parsedValue || !$dyn.peek(this.IsValid)) {
                    this._parsedValue = newValue;
                    if (this.ReferenceGroup && $dyn.peek(this.ReferenceGroup.isFocused)) {
                        this.ReferenceGroup.isChildDataDirty = true;
                    }
                    else {
                        result = this.setValue(newValue, forceChange, forceCommandCall);
                    }
                }
                return result;
            };
            /**
             * Get the _parsedValue as a date object in UTC
             * @returns The date object
             */
            Date.prototype.getDate = function () {
                var dateTime;
                var dateMoment = moment.utc(this._parsedValue, this.valueFormatPattern);
                if (dateMoment && dateMoment.isValid()) {
                    dateTime = dateMoment.toDate();
                }
                return dateTime;
            };
            /**
             * Gets user session date as a moment object
             * @returns Session date in a moment object
             */
            Date.prototype.getSessionDateMoment = function () {
                if ($dyn.user().UserSessionDate()) {
                    var userMoment = moment.tz($dyn.user().UserSessionDate(), "User");
                    var sessionDateMoment = moment().utc();
                    sessionDateMoment.year(userMoment.year());
                    sessionDateMoment.month(userMoment.month());
                    sessionDateMoment.date(userMoment.date());
                    return sessionDateMoment;
                }
                return this.getTodayMoment();
            };
            Date.prototype.isSessionDateToday = function () {
                var _this = this;
                if (this._isSessionDateToday === undefined) {
                    var todayMoment = this.getTodayMoment();
                    var sessionMoment = this.getSessionDateMoment();
                    this._isSessionDateToday = sessionMoment.isSame(todayMoment, "day");
                    this.sessionDateObserver = $dyn.observe($dyn.user().UserSessionDate, function () {
                        _this._isSessionDateToday = undefined;
                    }, this, undefined, true);
                }
                return this._isSessionDateToday;
            };
            Date.prototype.getTodayButtonLabel = function () {
                return this.isSessionDateToday() ? $dyn.label("Input_DatePickerToday") : $dyn.label("Input_DatePickerSessionDate");
            };
            /**
             * Open the date picker
             * @returns True if attempting to open the lookup, false if the lookup was already open
             */
            Date.prototype.showPicker = function () {
                var _this = this;
                if (!this.pickerWasOpenOnMouseDown && !this.pickerOpen()) {
                    // Using a timeout of 0 to open the picker after the mouseup event has reached the root.
                    // This is done to avoid the jQuery widget immediately closing the widget when it is opened.
                    $dyn.async(function () {
                        $dyn.util.showDatePicker(_this.$inputElement, _this);
                    }, 0, "Show date picker");
                    return true;
                }
                return false;
            };
            /**
             * updates internal flag if picker isopen - we cant see pickerOpen when jqwidgets closes the flyout on click
             */
            Date.prototype.checkPickerState = function () {
                // make sure it isnt open
                if (this.pickerOpen()) {
                    this.pickerWasOpenOnMouseDown = true;
                }
                else {
                    this.pickerWasOpenOnMouseDown = false;
                }
            };
            Date.prototype.keyDown = function (evt) {
                if (this.pickerOpen()) {
                    if ($dyn.util.isShortcutKeyPressed(evt, { alt: true, keyCode: [$dyn.ui.KeyCodes.rightArrow, $dyn.ui.KeyCodes.leftArrow] })) {
                        // The user has performed the browser back/forward shortcut, we need to close the picker.
                        evt.stopImmediatePropagation();
                        this.$inputElement.datepicker("hide");
                    }
                    else if ($dyn.util.isShortcutKeyPressed(evt, { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow })) {
                        var $widget = this.$inputElement.datepicker("widget");
                        $widget.find("a.ui-state-active").focus();
                        evt.stopPropagation();
                    }
                    else {
                        // By default if the picker is open it will be handling all keypresses.
                        evt.stopPropagation();
                    }
                    $dyn.log.stopPropagation && $dyn.log.stopPropagation("DatePicker is open and handling keystrokes on input.");
                }
                else {
                    $dyn.util.handleShortcuts(this, evt);
                }
            };
            Date.prototype.dispose = function () {
                if (this.sessionDateObserver) {
                    this.sessionDateObserver.dispose();
                }
                _super.prototype.dispose.call(this);
            };
            Date.prototype.updateParsedValue = function (newValue) {
                this._parsedValue = newValue;
            };
            Date.prototype.attached = function () {
                _super.prototype.attached.call(this);
                this.pickerOpen = $dyn.observable(false);
            };
            Date.prototype._formatAsDisplayValue = function (rawValue) {
                return this._formatDateValueForDisplay(rawValue);
            };
            Date.prototype.lastValidFormattedValue = function () {
                return this._formatDateValueForDisplay($dyn.value(this.Value));
            };
            /**
             * Create the format patterns for the control
             * @returns The computed that has a getter which gets the date formats
             */
            Date.prototype._createFormatPatterns = function () {
                var _this = this;
                return $dyn.computed(function () {
                    return $dyn.util.getDateFormat(_this);
                });
            };
            /**
             * Apply the control's time zone preference to a moment object
             * @param moment The moment object
             * @returns The moment object with the time zone prefernce applied
             */
            Date.prototype._applyTimeZonePreference = function (moment) {
                if ($dyn.value(this.TimeZonePreference) === $dyn.util.TimeZonePreference.none) {
                    moment.utc();
                }
                else {
                    moment.tz("User");
                }
                return moment;
            };
            /**
             * Gets the format used to parse the user entered value
             * @returns The parse format for the control
             */
            Date.prototype.parseFormat = function () {
                var format = "";
                if ($dyn.value(this.formatPatterns) && $dyn.value(this.formatPatterns).parse) {
                    format = $dyn.value(this.formatPatterns).parse;
                }
                return format;
            };
            /**
             * Transform a date string from the value format to the display format
             * @param value The date string in the value format
             * @returns The date string in the display format
             */
            Date.prototype._formatDateValueForDisplay = function (value) {
                var maxDateAsString = moment($dyn.util.time.maxDate).utc().format(this.valueFormatPattern);
                var dateString;
                if (!this.pickerOpen() && $dyn.value(this.MaxDateLabel) && value === maxDateAsString) {
                    // They are using the max date, replace the value with the max date label.
                    dateString = $dyn.value(this.MaxDateLabel);
                }
                else {
                    var dateAsMoment = this.getMoment(value);
                    if (this.pickerOpen()) {
                        dateString = dateAsMoment.format(this.momentDatePickerOpenFormatPattern);
                    }
                    else {
                        dateString = dateAsMoment.format(this.displayFormat());
                    }
                }
                return dateString;
            };
            /**
             * Parses a string into a moment object
             * @param value The string value to be parsed
             * @returns The parsed moment object
             */
            Date.prototype.parseMoment = function (value) {
                var dateTime;
                if (value.toLocaleUpperCase() === "T") {
                    // 'T' or 'D' should preserve the current time, if present
                    dateTime = this.getTodayMoment();
                }
                else if (value.toLocaleUpperCase() === "D") {
                    dateTime = this.getSessionDateMoment();
                }
                else if ($dyn.value(this.MaxDateLabel) && value.toLocaleUpperCase() === $dyn.value(this.MaxDateLabel).toLocaleUpperCase()) {
                    // User has entered the max date.
                    dateTime = moment($dyn.util.time.maxDate);
                }
                else if (this._isCondensedDate(value)) {
                    dateTime = this._parseMomentInPreferedTimeZone(value, this._findMatchingCondensedFormat(value));
                }
                else {
                    dateTime = this._parseMomentInPreferedTimeZone(value, this.parseFormat());
                }
                return dateTime;
            };
            /**
             * Determines if a date string is in a condensed date format
             * @param value The date string
             * @returns True if the date was in a recognized condensed format, otherwise false
             */
            Date.prototype._isCondensedDate = function (value) {
                var length = value.length;
                var onlyDigits = true;
                var isCondensedDate = false;
                for (var i = 0; i < length; i++) {
                    if (value[i] < "0" || value[i] > "9") {
                        onlyDigits = false;
                        break;
                    }
                }
                // A value is only considered parsable by a condensed format if it is only digits and matches one the of condensed formats in length.
                isCondensedDate = onlyDigits && (this._findMatchingCondensedFormat(value) ? true : false);
                return isCondensedDate;
            };
            /**
             * Finds the matching format for a condensed date string
             * @param value The date string
             * @returns The matched date format, or undefined if none matched
             */
            Date.prototype._findMatchingCondensedFormat = function (value) {
                // For condensed formats we can only specify one format so check if we have a condensed pattern that matches the length.
                var formats;
                if ($dyn.value(this.formatPatterns) && $dyn.value(this.formatPatterns).parse) {
                    formats = $dyn.value(this.formatPatterns).condensedParse;
                }
                if (formats && formats.length) {
                    var length_1 = formats.length;
                    for (var i = 0; i < length_1; i++) {
                        if (formats[i].length === value.length) {
                            // Length is the same, so this should be the proper condensed format to parse with.
                            return formats[i];
                        }
                    }
                }
                return undefined;
            };
            /**
             * Parse a date string with a given format in the control's preferred time zone
             * @param value The date string
             * @param parseFormat The specified parse format
             * @returns The parsed moment object with the preferred time zone applied
             */
            Date.prototype._parseMomentInPreferedTimeZone = function (value, parseFormat) {
                var dateTime;
                if ($dyn.value(this.TimeZonePreference) === $dyn.util.TimeZonePreference.none) {
                    dateTime = moment.utc(value, parseFormat);
                }
                else {
                    dateTime = moment.tz(value, parseFormat, "User");
                }
                /*
                    Bug 296219: Date Control - Leap Day silently defaults to next valid leap day when entered with a year.
                    Special case for when the user typed 2/29/2019 and it was getting resolved with the M/D/YY pattern as 2/29/20
                    and thus the value was resolving to 2/29/2020 instead of giving a validation warning for invalid date.
                 */
                if (dateTime.isValid() &&
                    dateTime.month() === 1 &&
                    dateTime.date() === 29 &&
                    dateTime.year() === 2020 &&
                    dateTime._f && // dateTime._f is the format that moment ultimately used for the parsing
                    dateTime._f.indexOf("YYYY") === -1) {
                    // Parsed date is 2/29/2020 and parse format used for year was not YYYY
                    var found = value.match(/20(\d\d)/);
                    if (found && found.length > 0 && found[0] !== "2020" && parseFormat && Array.isArray(parseFormat)) {
                        // remove any formats that don't have YYYY and perform the parse again to get the correct validation
                        var newParseFormats = parseFormat.filter(function (format) { return format.indexOf("YYYY") !== -1; });
                        if (newParseFormats.length > 0) {
                            dateTime = this._parseMomentInPreferedTimeZone(value, newParseFormats);
                        }
                    }
                }
                return dateTime;
            };
            return Date;
        }(controls.Input));
        controls.Date = Date;
        Date.prototype.IgnoreTime = true;
        // The value should be in the ISO 8601 standard date format.
        Date.prototype.valueFormatPattern = "YYYY-MM-DD";
        Date.prototype.errorMessageLabel = "Input_InvalidDateValue";
        Date.prototype.DateDay = $dyn.ui.autoValue;
        Date.prototype.DateFormat = $dyn.ui.autoValue;
        Date.prototype.DateMonth = $dyn.ui.autoValue;
        Date.prototype.DateSeparator = $dyn.ui.autoValue;
        Date.prototype.DateYear = $dyn.ui.autoValue;
        Date.prototype.CanOpenLookupForm = false;
        Date.prototype.LookupButton = true;
        Date.prototype.MaxDateLabel = "";
        Date.prototype.TimeZoneName = "";
        Date.prototype.TimeZonePreference = $dyn.util.TimeZonePreference.none;
        Date.prototype.ShowTimeZoneIndicator = false;
        $dyn.ui.addObservablePropertiesToPrototype(controls.Input.prototype, {
            pickerOpen: false,
        });
        // tslint:disable:object-literal-sort-keys
        // TODO: Add entries for datepicker so it shows up in available shortcuts when picker is open
        var dateShortcuts = {
            OpenLookup: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function () {
                    var stopPropagationAndPreventDefault = false;
                    if ($dyn.value(this.LookupButton) && this.allowUserChanges()) {
                        if ($dyn.value(this.CanOpenLookupForm)) {
                            stopPropagationAndPreventDefault = $dyn.applyFunction(controls.Input.prototype.Shortcuts.OpenLookup.Handler, this);
                        }
                        else {
                            stopPropagationAndPreventDefault = this.showPicker();
                        }
                    }
                    return stopPropagationAndPreventDefault;
                },
                RecordTelemetry: false,
                ShowToUser: function () { return ($dyn.value(this.LookupButton) && this.allowUserChanges()); },
                Description: $dyn.label("Input_OpenDropDown")
            },
        };
        Date.prototype.Shortcuts = $dyn.extendPrototype(controls.Input.prototype.Shortcuts, dateShortcuts);
        $dyn.adapter({ id: "Date", controlType: "Date", template: "DateTime" });
        $dyn.adapter({ id: "DateSummary", controlType: "Date", template: "SummaryField" });
        $dyn.adapter({ id: "DateLabel", controlType: "Date", template: "Label" });
        $dyn.adapter({ id: "DateCardCell", controlType: "Date", template: "CardCell" });
        var DateCell = /** @class */ (function (_super) {
            __extends(DateCell, _super);
            function DateCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = $dyn.observable(true);
                return _this;
            }
            DateCell.prototype.updateValue = function () {
                return this._onChange();
            };
            DateCell.prototype.addMessage = function (messageId) {
                if (!this.messages) {
                    this.messages = [];
                }
                this.messages.push(messageId);
            };
            DateCell.prototype._onChange = function () {
                var isDirty = false;
                if (this._committedValue !== this.currentValue) {
                    isDirty = true;
                    this._committedValue = this.currentValue;
                    // Raise a retargeted "change" event
                    this.RaiseEvent($dyn.ui.ChangeEvent, {
                        bubbles: true,
                    });
                }
                return isDirty;
            };
            DateCell.prototype._setValue = function () {
                // Force the value to be dirty
                this._committedValue = undefined;
            };
            DateCell.prototype.GetState = function () {
                // todo: Check against value?
                return {
                    formattedValue: this.currentValue,
                    messages: this.messages
                };
            };
            DateCell.prototype.ApplyState = function (clientState) {
                var retVal = $.Deferred();
                var formattedValue = clientState && clientState.formattedValue;
                if (formattedValue !== undefined) {
                    this.currentValue = formattedValue;
                }
                retVal.resolve();
                return retVal;
            };
            DateCell.prototype.attached = function () {
                this._ = {};
                _super.prototype.attached.call(this);
                this._committedValue = this.currentValue;
                this.Value = $dyn.observable(this._committedValue);
            };
            Object.defineProperty(DateCell.prototype, "currentValue", {
                get: function () {
                    return this._.input.value;
                },
                set: function (value) {
                    this._.input.value = value;
                },
                enumerable: false,
                configurable: true
            });
            return DateCell;
        }(Date));
        controls.DateCell = DateCell;
        $dyn.ui.addPropertiesToPrototype(DateCell.prototype, {
            validating: { defaultValue: false, attribute: "data-dyn-validating" }
        });
        $dyn.cellAdapter({ id: "Date", template: "InputCell" });
        $dyn.cellAdapter({ id: "Date", controlType: "DateCell", template: "InputCellEditor", type: $dyn.cellTypes.editor });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Date.js.map
